import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusBillerExportFieldsFragment = { readonly __typename?: 'EpocusBillerExport', readonly id: string, readonly batchNumber: number, readonly status: Types.EpocusBillerExportStatus, readonly studyCount: number, readonly chargeLineCount: number, readonly fileName: string, readonly createdAt: string, readonly builtAt?: string | null, readonly expiresAt?: string | null, readonly failureReason?: string | null };

export type EpocusBillerExportsQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusBillerExportsQuery = { readonly __typename?: 'Query', readonly epocusBillerExports: ReadonlyArray<{ readonly __typename?: 'EpocusBillerExport', readonly id: string, readonly batchNumber: number, readonly status: Types.EpocusBillerExportStatus, readonly studyCount: number, readonly chargeLineCount: number, readonly fileName: string, readonly createdAt: string, readonly builtAt?: string | null, readonly expiresAt?: string | null, readonly failureReason?: string | null }> };

export type EpocusBillerExportScopeQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  from?: Types.InputMaybe<Types.Scalars['DateTime']>;
  to?: Types.InputMaybe<Types.Scalars['DateTime']>;
}>;


export type EpocusBillerExportScopeQuery = { readonly __typename?: 'Query', readonly epocusBillerExportScope: { readonly __typename?: 'EpocusBillerExportScope', readonly readyCount: number, readonly amendedCount: number, readonly incompleteCount: number, readonly heldCount: number } };

export type CreateEpocusBillerExportMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  from?: Types.InputMaybe<Types.Scalars['DateTime']>;
  to?: Types.InputMaybe<Types.Scalars['DateTime']>;
}>;


export type CreateEpocusBillerExportMutation = { readonly __typename?: 'Mutation', readonly createEpocusBillerExport?: { readonly __typename?: 'EpocusBillerExport', readonly id: string, readonly batchNumber: number, readonly status: Types.EpocusBillerExportStatus, readonly studyCount: number, readonly chargeLineCount: number, readonly fileName: string, readonly createdAt: string, readonly builtAt?: string | null, readonly expiresAt?: string | null, readonly failureReason?: string | null } | null };

export type RetryEpocusBillerExportMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  exportId: Types.Scalars['ID'];
}>;


export type RetryEpocusBillerExportMutation = { readonly __typename?: 'Mutation', readonly retryEpocusBillerExport: { readonly __typename?: 'EpocusBillerExport', readonly id: string, readonly batchNumber: number, readonly status: Types.EpocusBillerExportStatus, readonly studyCount: number, readonly chargeLineCount: number, readonly fileName: string, readonly createdAt: string, readonly builtAt?: string | null, readonly expiresAt?: string | null, readonly failureReason?: string | null } };

export type RequestEpocusBillerExportDownloadMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  exportId: Types.Scalars['ID'];
}>;


export type RequestEpocusBillerExportDownloadMutation = { readonly __typename?: 'Mutation', readonly requestEpocusBillerExportDownload: { readonly __typename?: 'EpocusBillerExportDownload', readonly url?: string | null, readonly zipPassword?: string | null, readonly export: { readonly __typename?: 'EpocusBillerExport', readonly id: string, readonly batchNumber: number, readonly status: Types.EpocusBillerExportStatus, readonly studyCount: number, readonly chargeLineCount: number, readonly fileName: string, readonly createdAt: string, readonly builtAt?: string | null, readonly expiresAt?: string | null, readonly failureReason?: string | null } } };

export const EpocusBillerExportFieldsFragmentDoc = gql`
    fragment EpocusBillerExportFields on EpocusBillerExport {
  id
  batchNumber
  status
  studyCount
  chargeLineCount
  fileName
  createdAt
  builtAt
  expiresAt
  failureReason
}
    `;
export const EpocusBillerExportsDocument = gql`
    query EpocusBillerExports($programId: ID!) {
  epocusBillerExports(programId: $programId) {
    ...EpocusBillerExportFields
  }
}
    ${EpocusBillerExportFieldsFragmentDoc}`;

/**
 * __useEpocusBillerExportsQuery__
 *
 * To run a query within a React component, call `useEpocusBillerExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusBillerExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusBillerExportsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusBillerExportsQuery(baseOptions: Apollo.QueryHookOptions<EpocusBillerExportsQuery, EpocusBillerExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusBillerExportsQuery, EpocusBillerExportsQueryVariables>(EpocusBillerExportsDocument, options);
      }
export function useEpocusBillerExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusBillerExportsQuery, EpocusBillerExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusBillerExportsQuery, EpocusBillerExportsQueryVariables>(EpocusBillerExportsDocument, options);
        }
export type EpocusBillerExportsQueryHookResult = ReturnType<typeof useEpocusBillerExportsQuery>;
export type EpocusBillerExportsLazyQueryHookResult = ReturnType<typeof useEpocusBillerExportsLazyQuery>;
export type EpocusBillerExportsQueryResult = Apollo.QueryResult<EpocusBillerExportsQuery, EpocusBillerExportsQueryVariables>;
export const EpocusBillerExportScopeDocument = gql`
    query EpocusBillerExportScope($programId: ID!, $from: DateTime, $to: DateTime) {
  epocusBillerExportScope(programId: $programId, from: $from, to: $to) {
    readyCount
    amendedCount
    incompleteCount
    heldCount
  }
}
    `;

/**
 * __useEpocusBillerExportScopeQuery__
 *
 * To run a query within a React component, call `useEpocusBillerExportScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusBillerExportScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusBillerExportScopeQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useEpocusBillerExportScopeQuery(baseOptions: Apollo.QueryHookOptions<EpocusBillerExportScopeQuery, EpocusBillerExportScopeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusBillerExportScopeQuery, EpocusBillerExportScopeQueryVariables>(EpocusBillerExportScopeDocument, options);
      }
export function useEpocusBillerExportScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusBillerExportScopeQuery, EpocusBillerExportScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusBillerExportScopeQuery, EpocusBillerExportScopeQueryVariables>(EpocusBillerExportScopeDocument, options);
        }
export type EpocusBillerExportScopeQueryHookResult = ReturnType<typeof useEpocusBillerExportScopeQuery>;
export type EpocusBillerExportScopeLazyQueryHookResult = ReturnType<typeof useEpocusBillerExportScopeLazyQuery>;
export type EpocusBillerExportScopeQueryResult = Apollo.QueryResult<EpocusBillerExportScopeQuery, EpocusBillerExportScopeQueryVariables>;
export const CreateEpocusBillerExportDocument = gql`
    mutation CreateEpocusBillerExport($programId: ID!, $from: DateTime, $to: DateTime) {
  createEpocusBillerExport(programId: $programId, from: $from, to: $to) {
    ...EpocusBillerExportFields
  }
}
    ${EpocusBillerExportFieldsFragmentDoc}`;
export type CreateEpocusBillerExportMutationFn = Apollo.MutationFunction<CreateEpocusBillerExportMutation, CreateEpocusBillerExportMutationVariables>;

/**
 * __useCreateEpocusBillerExportMutation__
 *
 * To run a mutation, you first call `useCreateEpocusBillerExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpocusBillerExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpocusBillerExportMutation, { data, loading, error }] = useCreateEpocusBillerExportMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCreateEpocusBillerExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateEpocusBillerExportMutation, CreateEpocusBillerExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEpocusBillerExportMutation, CreateEpocusBillerExportMutationVariables>(CreateEpocusBillerExportDocument, options);
      }
export type CreateEpocusBillerExportMutationHookResult = ReturnType<typeof useCreateEpocusBillerExportMutation>;
export type CreateEpocusBillerExportMutationResult = Apollo.MutationResult<CreateEpocusBillerExportMutation>;
export type CreateEpocusBillerExportMutationOptions = Apollo.BaseMutationOptions<CreateEpocusBillerExportMutation, CreateEpocusBillerExportMutationVariables>;
export const RetryEpocusBillerExportDocument = gql`
    mutation RetryEpocusBillerExport($programId: ID!, $exportId: ID!) {
  retryEpocusBillerExport(programId: $programId, exportId: $exportId) {
    ...EpocusBillerExportFields
  }
}
    ${EpocusBillerExportFieldsFragmentDoc}`;
export type RetryEpocusBillerExportMutationFn = Apollo.MutationFunction<RetryEpocusBillerExportMutation, RetryEpocusBillerExportMutationVariables>;

/**
 * __useRetryEpocusBillerExportMutation__
 *
 * To run a mutation, you first call `useRetryEpocusBillerExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryEpocusBillerExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryEpocusBillerExportMutation, { data, loading, error }] = useRetryEpocusBillerExportMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useRetryEpocusBillerExportMutation(baseOptions?: Apollo.MutationHookOptions<RetryEpocusBillerExportMutation, RetryEpocusBillerExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryEpocusBillerExportMutation, RetryEpocusBillerExportMutationVariables>(RetryEpocusBillerExportDocument, options);
      }
export type RetryEpocusBillerExportMutationHookResult = ReturnType<typeof useRetryEpocusBillerExportMutation>;
export type RetryEpocusBillerExportMutationResult = Apollo.MutationResult<RetryEpocusBillerExportMutation>;
export type RetryEpocusBillerExportMutationOptions = Apollo.BaseMutationOptions<RetryEpocusBillerExportMutation, RetryEpocusBillerExportMutationVariables>;
export const RequestEpocusBillerExportDownloadDocument = gql`
    mutation RequestEpocusBillerExportDownload($programId: ID!, $exportId: ID!) {
  requestEpocusBillerExportDownload(programId: $programId, exportId: $exportId) {
    export {
      ...EpocusBillerExportFields
    }
    url
    zipPassword
  }
}
    ${EpocusBillerExportFieldsFragmentDoc}`;
export type RequestEpocusBillerExportDownloadMutationFn = Apollo.MutationFunction<RequestEpocusBillerExportDownloadMutation, RequestEpocusBillerExportDownloadMutationVariables>;

/**
 * __useRequestEpocusBillerExportDownloadMutation__
 *
 * To run a mutation, you first call `useRequestEpocusBillerExportDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestEpocusBillerExportDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestEpocusBillerExportDownloadMutation, { data, loading, error }] = useRequestEpocusBillerExportDownloadMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useRequestEpocusBillerExportDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RequestEpocusBillerExportDownloadMutation, RequestEpocusBillerExportDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestEpocusBillerExportDownloadMutation, RequestEpocusBillerExportDownloadMutationVariables>(RequestEpocusBillerExportDownloadDocument, options);
      }
export type RequestEpocusBillerExportDownloadMutationHookResult = ReturnType<typeof useRequestEpocusBillerExportDownloadMutation>;
export type RequestEpocusBillerExportDownloadMutationResult = Apollo.MutationResult<RequestEpocusBillerExportDownloadMutation>;
export type RequestEpocusBillerExportDownloadMutationOptions = Apollo.BaseMutationOptions<RequestEpocusBillerExportDownloadMutation, RequestEpocusBillerExportDownloadMutationVariables>;